(function() {
  'use strict';

  angular.module('ringbaPortal').component('concurrencyMatrix', {
    bindings: {
      targetObject: '=',
      disableConcurrencyCap: '=',
      showAdvancedConcurrency: '='
    },
    controller: ConcurrencyMatrixController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/concurrency-matrix/concurrency-matrix.view.html'
  });

  function ConcurrencyMatrixController(
    _
  ) {
    'ngInject';

    const vm = this;
    vm.allDays = [];
    vm.allHours = [];
    vm.daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    vm.hours = _.range(24);
    vm.showMatrix = false;
    vm.$onInit = onInit;

    vm.dayUpdate = dayUpdate;
    vm.deleteMatrix = deleteMatrix;
    vm.hourUpdate = hourUpdate;
    vm.matrixInit = matrixInit;
    vm.resetMatrix = resetMatrix;
    vm.toggleMatrix = toggleMatrix;
    vm.useMatrix = useMatrix;
    vm.updateAll = updateAll;

    function onInit() {
      useMatrix();
      _setInitialAllValues(vm.targetObject.schedule.callConcurrencyMatrix);
    }

    function dayUpdate(column, value, $event) {
      // Check if function is called from inside the controller itself,
      // or key is entered is a number
      // or value has being changed
      if (!$event || ($event && $event.key && !isNaN($event.key)) || (vm.oldValue !== value)) {
        _.forEach(vm.hours, function(hour) {
          vm.targetObject.schedule.callConcurrencyMatrix[column][hour] = value;
        });
      }
    }

    function deleteMatrix() {
      toggleMatrix();
      vm.disableConcurrencyCap = !vm.disableConcurrencyCap;
      vm.targetObject.schedule.callConcurrencyMatrix = null;
      vm.allHours = [];
      vm.allDays = [];
    }

    function hourUpdate(row, value, $event) {
      // Check if function is called from inside the controller itself,
      // or key is entered is a number
      // or value has being changed
      if (!$event || ($event && $event.key && !isNaN($event.key)) || (vm.oldValue !== value)) {
        vm.oldValue = value;
        _.forEach(vm.daysOfWeek, function(day, index) {
          vm.targetObject.schedule.callConcurrencyMatrix[index][row] = value;
        });
      }
    }

    function matrixInit() {
      const weekMatrix = [];
      _.forEach(vm.daysOfWeek, function() {
        const dayMatrix = [];
        _.forEach(vm.hours, function() {
          if (vm.targetObject.schedule.concurrencyCap && (parseInt(vm.targetObject.schedule.concurrencyCap) >= 0)) {
            dayMatrix.push(parseInt(vm.targetObject.schedule.concurrencyCap));
          } else {
            dayMatrix.push(null);
          }
        });
        weekMatrix.push(dayMatrix);
      });
      return weekMatrix;
    }

    function resetMatrix() {
      vm.targetObject.schedule.callConcurrencyMatrix = matrixInit();
      vm.allHours = [];
      vm.allDays = [];
      vm.allTime = undefined;
    }

    function toggleMatrix() {
      vm.showMatrix = !vm.showMatrix;
    }

    function useMatrix() {
      toggleMatrix();
      vm.targetObject.schedule = vm.targetObject.schedule || {};
      vm.targetObject.schedule.callConcurrencyMatrix = vm.targetObject.schedule.callConcurrencyMatrix || matrixInit();
      if (_isBasic(vm.targetObject.schedule.callConcurrencyMatrix)) {
        vm.allHours = _.cloneDeep(vm.targetObject.schedule.callConcurrencyMatrix[0]);
        vm.showAdvancedConcurrency = false;
      }
    }

    function updateAll(value) {
      for (let i = 0; i < vm.daysOfWeek.length; i++) {
        dayUpdate(i, value);
        vm.allDays[i] = value;
      }
      vm.allHours = _.range(24);
      _.fill(vm.allHours, value);
    }

    // Checks to see if all days are the same
    function _isBasic(matrix) {
      let basic = true;
      const compareDay = matrix[0];
      _.forEach(matrix, function(day) {
        if (!_.isEqual(compareDay, day)) {
          basic = false;
        }
      });
      return basic;
    }

    function _setInitialAllValues(matrix) {
      const compareHourValue = {};
      let allValuesSame = true;
      _.forEach(vm.daysOfWeek, function(day, key) {
        const compareDayValue = matrix[key][0];
        let same = true;

        _.forEach(vm.hours, function(hour) {
          compareHourValue[hour] = compareHourValue[hour] || { sameValue: true, day: key };
          compareHourValue[hour]['sameValue'] = (matrix[key][hour] === matrix[0][hour] && compareHourValue[hour]['sameValue']);
          if (matrix[key][hour] !== compareDayValue) {
            same = false;
            allValuesSame = false;
          }
        });

        if (same) {
          vm.allDays[key] = compareDayValue;
        }
      });

      _.forEach(compareHourValue, function (value, key) {
        if (value.sameValue) {
          vm.allHours[key] = matrix[value.day][key];
        } else {
          allValuesSame = false;
        }
      });

      if (allValuesSame) {
        vm.allTime = matrix[0][0];
      }
    }
  }
})();
